import React from "react";

const ContentLoader = () => {
  return (
    <div className="main-wrapper h-75 w-100">
      <div id="content-body-height" className="content-body h-100">
        <div className="global-body-container h-100">
          <div className="sk-three-bounce">
            <div className="sk-child sk-bounce1"></div>
            <div className="sk-child sk-bounce2"></div>
            <div className="sk-child sk-bounce3"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentLoader;
